export default {
    name: 'kendo-buttongroup-button',
    template: '<li><slot></slot></li>'
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButtonGroup/KendoButtonGroupButton.js